/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function() {
  $('.image-overlay__items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    arrows:false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 741,
        settings: "unslick"
      }
    ]
  });

  // TESTIMONIAL SECONDARY
  $('.testimonial-secondary-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots:false,
    arrows:true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          dots:true,
          arrows:false
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          dots:true,
          arrows:false
        }
      }
    ]
  });

  // CONTACT US
  $('.contact-us-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    arrows:false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
  });

  // TEXT WITH ICON SECONDARY
  $('.text-with-icon-secondary-list').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots:true,
    arrows:false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
  });

  // COMPLEMENTARY PRODUCTS
  setTimeout(function() {
    $('.complementary-products__inner').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      mobileFirst: false,
      responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
    });
  }, 1000)

  // HUMAN HARISSONS
  $('.human-harissons-inner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:false,
    arrows:true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          dots:true,
          arrows:false
        }
      }
    ]
  });

  // BLOG POSTS SECONDARY
  $('.article-list-secondary').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots:false,
    arrows:true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          dots:true,
          arrows:false
        }
      }
    ]
  });

  // JOURNEY INCEPTION  
   $('.journey-inception-main-slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     dots: false,
     focusOnSelect: true,
     centerMode: true,
     responsive: [
      {
        breakpoint: 999,
        settings: {
          dots:true,
          arrows:false
        }
      }
    ]
   });
  
   $('.journey-inception-nav-slider-item').click(function(e) {
     e.preventDefault();
     $(this).addClass('active').siblings().removeClass('active');
     var slideno = $(this).data('slide');
     $('.journey-inception-main-slider').slick('slickGoTo', slideno - 1);
   });

  // PRODUCT TAB NAVIGATION
    function scrollToSection(event) {
    var width = $(window).outerWidth();
    event.preventDefault();
    $(".product-tab-iner a").removeClass("active");
    $(this).addClass("active");
    var $section = $($(this).attr("href"));
    if(width>=999){
       $("html, body").animate(
        {
          scrollTop: $section.offset().top - 240,      
        },
        500
      ); 
    } else {
      $("html, body").animate(
        {
          scrollTop: $section.offset().top - 0,      
        },
        500
      );
    }   
  }
  $(".ptb_link").on("click", scrollToSection);

  function scrollToSectionn(event) {
    var width = $(window).outerWidth();
    event.preventDefault();
    var $section = $($(this).attr("href"));
    if(width>=999){
       $("html, body").animate(
        {
          scrollTop: $section.offset().top - 240,      
        },
        500
      ); 
    } else {
      $('#additoinal-info').find('.section_accordion_button_heading').click();
      $("html, body").animate(
        {
          scrollTop: $section.offset().top - 100,      
        },
        500
      );
    }   
  }
  $(".product-warranty-button, .button-scroll-to-section").on("click", scrollToSectionn);

  $("body").on("click", ".product-offer-copy-code", function () {
    var copy_text = $(this);
    var text = $(this).siblings('.offer-code-wrap-code').text();
    var $temp = $("<input>");
      
    $("drawer-content").append($temp);
    $temp.val(text).select();
    document.execCommand('copy');
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  $('.section_accordion_button_heading').click(function(){
    $(this).toggleClass('active');
    $(this).next('.section_accordion_content').slideToggle();
  });
  

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    var elementMidpoint = elementTop + $(this).outerHeight() / 2;
    return elementMidpoint > viewportTop && elementMidpoint < viewportBottom;
  };
  $(window).scroll(function() {
    var scrollDistance = $(window).scrollTop() + 310;
    var count = 0;
    $('.page-section').each(function(i) {
      if ($(this).isInViewport()) {
       $('.product-tab-row a.active').removeClass('active');
       $('.product-tab-row a').eq(i).addClass('active');
        count++
      }
    });
    if (count === 0) {
         $('.shopify-section--product-tab-nav').addClass('no-active-sections');
    } else {
       $('.shopify-section--product-tab-nav').removeClass('no-active-sections');
    }
  }).scroll();

  // TYPEWRITER INPUT
  const inputElement = document.getElementById("typewriter");
  var valuee = window.themeVariables.settings.typewriter;
  var textsToType = valuee.split(',');
    let textIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    function typeWriter() {
      const currentText = textsToType[textIndex];
      if (isDeleting) {
        // Update the placeholder by removing characters
        inputElement.placeholder = currentText.substring(0, charIndex);
        charIndex--;

        if (charIndex < 0) {
          isDeleting = false;
          textIndex = (textIndex + 1) % textsToType.length; // Move to the next text or loop
          setTimeout(typeWriter, 200); // Delay before typing the next text
        } else {
          setTimeout(typeWriter, 30); // Deleting speed
        }
      } else {
        // Update the placeholder by adding characters
        inputElement.placeholder = currentText.substring(0, charIndex);
        charIndex++;

        if (charIndex > currentText.length) {
          isDeleting = true;
          setTimeout(typeWriter, 1000); // Delay before starting to delete
        } else {
          setTimeout(typeWriter, 100); // Typing speed
        }
      }
    }
    setTimeout(typeWriter, 1000);

  
    // Select the section and the element to hide
    var section = document.querySelector('.footer');
    var elementToHide = document.querySelector('.enquire-button-section');
    
     function checkVisibility() {
      var rect = section.getBoundingClientRect();
      var isVisible = rect.top < window.innerHeight && rect.bottom > 0;
  
      // Toggle visibility of the element based on the section's visibility
      if (isVisible) {
        elementToHide.style.display = 'none';  // Hide the element
      } else {
        elementToHide.style.display = 'block'; // Show the element
      }
    }
    if(elementToHide){
      // Attach the scroll event
      window.addEventListener('scroll', checkVisibility);
      checkVisibility() 
    }   

  // Clear URL parameters without reloading the page
  function clearURLParameters() {
    // Get the current URL
    const url = new URL(window.location.href);
  
    // Remove all query parameters
    url.search = "";
  
    // Optionally, remove the fragment (everything after #)
    url.hash = "";
  
    // Update the URL without reloading the page
    window.history.replaceState(null, null, url.toString());
  }
  
  var live_url = window.location.href;
  var result = live_url.includes('form_type=customer');
  var resultischal = live_url.includes('/challenge');
  if(live_url.includes('customer_posted=true')){
    $('html, body').animate({
        scrollTop: $('.newsletter-secondary-inner').offset().top - 100
    }, 1000);
  }else if(result && !resultischal && $('.newsletter_form_sec').length != 0 && $('.newsletter_form_sec .errors').length == 0){
      const add_ele = document.createElement("p");
      add_ele.innerText = "You have already subscribed!";
      $('.newsletter_form_sec').prepend(add_ele);
      add_ele.classList.add('newsletter_already_subscribe','newsletter-form_message','form_message');     
      clearURLParameters();
      $('html, body').animate({
          scrollTop: $('.newsletter-secondary-inner').offset().top - 100
      }, 1000);
    // Scroll to the `.newsletter_form_sec` section and center it on the screen
    // const newsletterSection = document.querySelector('.newsletter-secondary-container');
    // if (newsletterSection) {
    //   newsletterSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    //   console.log('Scrolled to newsletter section');
    // } else {
    //   console.log('Newsletter section not found');
    // }
  }  

  
  if($(".continuous-timer-main").length > 0){
  
  // Set the countdown duration (1 hour in milliseconds)
  var countDownHours = parseInt(document.querySelectorAll(".continuous_timer")[0].getAttribute("sale_countdown_time_hours")) || 0;
  var countDownMinutes = parseInt(document.querySelectorAll(".continuous_timer")[0].getAttribute("sale_countdown_time_minutes")) || 0;
  var countDownDuration = (countDownHours * 60 * 60 * 1000) + (countDownMinutes * 60 * 1000);
  
  // Check if there's a stored start time in localStorage
  var storedStartTime = localStorage.getItem("startTime");
  var startTime;
  
  // If there's no stored start time, initialize it to the current time
  if (storedStartTime) {
    startTime = parseInt(storedStartTime, 10);
  } else {
    startTime = new Date().getTime();
    localStorage.setItem("startTime", startTime);
  }
  
  // Update the countdown every 1 second
  var x = setInterval(function () {
    // Get the current time
    var now = new Date().getTime();
  
    // Calculate the time elapsed since the start time
    var elapsed = now - startTime;
  
    // Find the remaining time in the current countdown
    var distance = countDownDuration - (elapsed % countDownDuration);
  
    // Time calculations for hours, minutes, and seconds
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
    // Build the display string
    var display = "";
    if (hours > 0) {
      display += ` &nbsp;<span>${hours}h</span>`;
    }
    display += ` &nbsp;<span>${minutes}m</span>` + ` &nbsp;<span>${seconds}s</span>`;
    // console.log('displayyy',display);
    // Output the result in an element with id="demo"
    document.getElementById("continuous_timerr").innerHTML = display;
  
    // Reset the start time if a new countdown cycle begins
    if (distance <= 0) {
      startTime = new Date().getTime();
      localStorage.setItem("startTime", startTime);
    }
  }, 1000);
  }
});


